import { csx } from '@vtex/admin-ui'

export const modalAction = csx({
  display: 'flex',

  'button:disabled': {
    cursor: 'initial',
  },
})

export const modalInfo = csx({
  paddingTop: '16px',

  a: {
    textDecoration: 'underline',
  },
})
